/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * refloopを知ったきっかけ
 */
export enum UserReferralSource {
  INSTAGRAM = "Instagram公式アカウント",
  TIKTOK = "TikTok公式アカウント",
  YOUTUBE = "YouTube公式アカウント",
  REFLOOP = "refloopマガジン（おでかけ記事）",
  GOOGLE_YAHOO = "Google / Yahoo 検索",
  REFERRAL = "知人からの紹介",
  OTHER = "その他"
}
